module.exports = __webpack_public_path__ + "static/media/logo-pinina.05044716.svg";